import styled from "@emotion/styled";
import React from "react";
import { Button } from "../Button";
import { Typography } from "../Typography";

const CardContainer = styled.div`
  background-color: #f6f6f6;
  height: 224px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 32px 32px 36px 32px;
  gap: 28px;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HeaderText = styled(Typography)`
  font-weight: 800 !important;
  color: ${({ theme }) => theme.colors.charcoalLight};
`;

const LowerContentText = styled(Typography)`
  color: ${({ theme }) => theme.colors.charcoalLight};
`;

export type EditDataCardProps = {
  className?: string;
  displayTitle: string;
  editTitle: string;
  isEditing: boolean;
  onOpenEdit: () => void;
  editContent: React.ReactNode;
  displayContent: React.ReactNode;
  displayLowerContent?: string;
  showEditToggle?: boolean;
  showBothContentsWhileEditing?: boolean;
};

export const EditDataCard = ({
  className,
  isEditing,
  displayTitle,
  editTitle,
  editContent,
  displayContent,
  displayLowerContent,
  showEditToggle = true,
  showBothContentsWhileEditing = false,
  onOpenEdit,
}: EditDataCardProps) => (
  <CardContainer className={className}>
    <TitleContainer>
      <HeaderText use="body2">
        {isEditing ? editTitle : displayTitle}
      </HeaderText>
      {showEditToggle && (
        <Button
          textWithUnderline
          text={isEditing ? "Cancel" : "Edit"}
          onClick={onOpenEdit}
          aria-label={isEditing ? `Cancel ${editTitle}` : `${editTitle}`}
        />
      )}
    </TitleContainer>
    <div>
      {isEditing && showBothContentsWhileEditing ? (
        <>
          {displayContent}
          {editContent}
        </>
      ) : isEditing ? (
        editContent
      ) : (
        displayContent
      )}
    </div>
    {displayLowerContent && !isEditing && (
      <div>
        <LowerContentText use="body2">{displayLowerContent}</LowerContentText>
      </div>
    )}
  </CardContainer>
);
